export default __webpack_public_path__ + "static/media/s_twi.f4270a63.svg";